import { NuxtAxiosInstance } from 'vue/types/vue';
import { AxiosRequestConfig } from 'axios';

import axiosInstance from './request';

export class AlbumApiService {
    private $axios?: NuxtAxiosInstance;

    constructor() {
        this.$axios = axiosInstance;
    }

    /**
     * @zh 历史逻辑，先 Record<string, any>
     */
    async getFeedAlbum(data: Record<string, any>, config?: AxiosRequestConfig) {
        const res = await this.$axios?.$$post?.<Record<string, any>>(`overseaAPI::/rest/o/w/pwa/feed/album`, data, config);

        return res;
    }
}

export const AlbumApi = new AlbumApiService();
